export const TimeZoneConsts = [
  {
    "id": "Dateline Standard Time",
    "displayName": "(UTC-12:00) International Date Line West",
    "standardName": "Dateline Standard Time",
    "offset": -12,
    "ianaTimeZone": "Etc/GMT+12"
  },
  {
    "id": "UTC-11",
    "displayName": "(UTC-11:00) Coordinated Universal Time",
    "standardName": "UTC-11",
    "offset": -11,
    "ianaTimeZone": "Etc/GMT+11"
  },
  {
    "id": "Aleutian Standard Time",
    "displayName": "(UTC-10:00) Aleutian Islands",
    "standardName": "Aleutian Standard Time",
    "offset": -10,
    "ianaTimeZone": "America/Adak"
  },
  {
    "id": "Hawaiian Standard Time",
    "displayName": "(UTC-10:00) Hawaii",
    "standardName": "Hawaiian Standard Time",
    "offset": -10,
    "ianaTimeZone": "Pacific/Honolulu"
  },
  {
    "id": "Marquesas Standard Time",
    "displayName": "(UTC-09:30) Marquesas Islands",
    "standardName": "Marquesas Standard Time",
    "offset": -9.5,
    "ianaTimeZone": "Pacific/Marquesas"
  },
  {
    "id": "Alaskan Standard Time",
    "displayName": "(UTC-09:00) Alaska",
    "standardName": "Alaskan Standard Time",
    "offset": -9,
    "ianaTimeZone": "America/Anchorage"
  },
  {
    "id": "UTC-09",
    "displayName": "(UTC-09:00) Coordinated Universal Time",
    "standardName": "UTC-09",
    "offset": -9,
    "ianaTimeZone": "Etc/GMT+9"
  },
  {
    "id": "Pacific Standard Time (Mexico)",
    "displayName": "(UTC-08:00) Baja California",
    "standardName": "Pacific Standard Time (Mexico)",
    "offset": -8,
    "ianaTimeZone": "America/Tijuana"
  },
  {
    "id": "UTC-08",
    "displayName": "(UTC-08:00) Coordinated Universal Time",
    "standardName": "UTC-08",
    "offset": -8,
    "ianaTimeZone": "Etc/GMT+8"
  },
  {
    "id": "Pacific Standard Time",
    "displayName": "(UTC-08:00) Pacific Time (US & Canada)",
    "standardName": "Pacific Standard Time",
    "offset": -8,
    "ianaTimeZone": "America/Los_Angeles"
  },
  {
    "id": "US Mountain Standard Time",
    "displayName": "(UTC-07:00) Arizona",
    "standardName": "US Mountain Standard Time",
    "offset": -7,
    "ianaTimeZone": "America/Phoenix"
  },
  {
    "id": "Mountain Standard Time (Mexico)",
    "displayName": "(UTC-07:00) La Paz, Mazatlan",
    "standardName": "Mountain Standard Time (Mexico)",
    "offset": -7,
    "ianaTimeZone": "America/Mazatlan"
  },
  {
    "id": "Mountain Standard Time",
    "displayName": "(UTC-07:00) Mountain Time (US & Canada)",
    "standardName": "Mountain Standard Time",
    "offset": -7,
    "ianaTimeZone": "America/Denver"
  },
  {
    "id": "Yukon Standard Time",
    "displayName": "(UTC-07:00) Yukon",
    "standardName": "Yukon Standard Time",
    "offset": -7,
    "ianaTimeZone": "America/Whitehorse"
  },
  {
    "id": "Central America Standard Time",
    "displayName": "(UTC-06:00) Central America",
    "standardName": "Central America Standard Time",
    "offset": -6,
    "ianaTimeZone": "America/Guatemala"
  },
  {
    "id": "Central Standard Time",
    "displayName": "(UTC-06:00) Central Time (US & Canada)",
    "standardName": "Central Standard Time",
    "offset": -6,
    "ianaTimeZone": "America/Chicago"
  },
  {
    "id": "Easter Island Standard Time",
    "displayName": "(UTC-06:00) Easter Island",
    "standardName": "Easter Island Standard Time",
    "offset": -6,
    "ianaTimeZone": "Pacific/Easter"
  },
  {
    "id": "Central Standard Time (Mexico)",
    "displayName": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
    "standardName": "Central Standard Time (Mexico)",
    "offset": -6,
    "ianaTimeZone": "America/Mexico_City"
  },
  {
    "id": "Canada Central Standard Time",
    "displayName": "(UTC-06:00) Saskatchewan",
    "standardName": "Canada Central Standard Time",
    "offset": -6,
    "ianaTimeZone": "America/Regina"
  },
  {
    "id": "SA Pacific Standard Time",
    "displayName": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
    "standardName": "SA Pacific Standard Time",
    "offset": -5,
    "ianaTimeZone": "America/Bogota"
  },
  {
    "id": "Eastern Standard Time (Mexico)",
    "displayName": "(UTC-05:00) Chetumal",
    "standardName": "Eastern Standard Time (Mexico)",
    "offset": -5,
    "ianaTimeZone": "America/Cancun"
  },
  {
    "id": "Eastern Standard Time",
    "displayName": "(UTC-05:00) Eastern Time (US & Canada)",
    "standardName": "Eastern Standard Time",
    "offset": -5,
    "ianaTimeZone": "America/New_York"
  },
  {
    "id": "Haiti Standard Time",
    "displayName": "(UTC-05:00) Haiti",
    "standardName": "Haiti Standard Time",
    "offset": -5,
    "ianaTimeZone": "America/Port-au-Prince"
  },
  {
    "id": "Cuba Standard Time",
    "displayName": "(UTC-05:00) Havana",
    "standardName": "Cuba Standard Time",
    "offset": -5,
    "ianaTimeZone": "America/Havana"
  },
  {
    "id": "US Eastern Standard Time",
    "displayName": "(UTC-05:00) Indiana (East)",
    "standardName": "US Eastern Standard Time",
    "offset": -5,
    "ianaTimeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "Turks And Caicos Standard Time",
    "displayName": "(UTC-05:00) Turks and Caicos",
    "standardName": "Turks and Caicos Standard Time",
    "offset": -5,
    "ianaTimeZone": "America/Grand_Turk"
  },
  {
    "id": "Atlantic Standard Time",
    "displayName": "(UTC-04:00) Atlantic Time (Canada)",
    "standardName": "Atlantic Standard Time",
    "offset": -4,
    "ianaTimeZone": "America/Halifax"
  },
  {
    "id": "Venezuela Standard Time",
    "displayName": "(UTC-04:00) Caracas",
    "standardName": "Venezuela Standard Time",
    "offset": -4,
    "ianaTimeZone": "America/Caracas"
  },
  {
    "id": "Central Brazilian Standard Time",
    "displayName": "(UTC-04:00) Cuiaba",
    "standardName": "Central Brazilian Standard Time",
    "offset": -4,
    "ianaTimeZone": "America/Cuiaba"
  },
  {
    "id": "SA Western Standard Time",
    "displayName": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
    "standardName": "SA Western Standard Time",
    "offset": -4,
    "ianaTimeZone": "America/La_Paz"
  },
  {
    "id": "Pacific SA Standard Time",
    "displayName": "(UTC-04:00) Santiago",
    "standardName": "Pacific SA Standard Time",
    "offset": -4,
    "ianaTimeZone": "America/Santiago"
  },
  {
    "id": "Newfoundland Standard Time",
    "displayName": "(UTC-03:30) Newfoundland",
    "standardName": "Newfoundland Standard Time",
    "offset": -3.5,
    "ianaTimeZone": "America/St_Johns"
  },
  {
    "id": "Tocantins Standard Time",
    "displayName": "(UTC-03:00) Araguaina",
    "standardName": "Tocantins Standard Time",
    "offset": -3,
    "ianaTimeZone": "America/Araguaina"
  },
  {
    "id": "Paraguay Standard Time",
    "displayName": "(UTC-03:00) Asuncion",
    "standardName": "Paraguay Standard Time",
    "offset": -3,
    "ianaTimeZone": "America/Asuncion"
  },
  {
    "id": "E. South America Standard Time",
    "displayName": "(UTC-03:00) Brasilia",
    "standardName": "E. South America Standard Time",
    "offset": -3,
    "ianaTimeZone": "America/Sao_Paulo"
  },
  {
    "id": "SA Eastern Standard Time",
    "displayName": "(UTC-03:00) Cayenne, Fortaleza",
    "standardName": "SA Eastern Standard Time",
    "offset": -3,
    "ianaTimeZone": "America/Cayenne"
  },
  {
    "id": "Argentina Standard Time",
    "displayName": "(UTC-03:00) City of Buenos Aires",
    "standardName": "Argentina Standard Time",
    "offset": -3,
    "ianaTimeZone": "America/Argentina/Buenos_Aires"
  },
  {
    "id": "Montevideo Standard Time",
    "displayName": "(UTC-03:00) Montevideo",
    "standardName": "Montevideo Standard Time",
    "offset": -3,
    "ianaTimeZone": "America/Montevideo"
  },
  {
    "id": "Magallanes Standard Time",
    "displayName": "(UTC-03:00) Punta Arenas",
    "standardName": "Magallanes Standard Time",
    "offset": -3,
    "ianaTimeZone": "America/Punta_Arenas"
  },
  {
    "id": "Saint Pierre Standard Time",
    "displayName": "(UTC-03:00) Saint Pierre and Miquelon",
    "standardName": "Saint Pierre Standard Time",
    "offset": -3,
    "ianaTimeZone": "America/Miquelon"
  },
  {
    "id": "Bahia Standard Time",
    "displayName": "(UTC-03:00) Salvador",
    "standardName": "Bahia Standard Time",
    "offset": -3,
    "ianaTimeZone": "America/Bahia"
  },
  {
    "id": "UTC-02",
    "displayName": "(UTC-02:00) Coordinated Universal Time",
    "standardName": "UTC-02",
    "offset": -2,
    "ianaTimeZone": "Etc/GMT+2"
  },
  {
    "id": "Greenland Standard Time",
    "displayName": "(UTC-02:00) Greenland",
    "standardName": "Greenland Standard Time",
    "offset": -2,
    "ianaTimeZone": "America/Godthab"
  },
  {
    "id": "Mid-Atlantic Standard Time",
    "displayName": "(UTC-02:00) Mid-Atlantic - Old",
    "standardName": "Mid-Atlantic Standard Time",
    "offset": -2,
    "ianaTimeZone": "Etc/GMT+2"
  },
  {
    "id": "Azores Standard Time",
    "displayName": "(UTC-01:00) Azores",
    "standardName": "Azores Standard Time",
    "offset": -1,
    "ianaTimeZone": "Atlantic/Azores"
  },
  {
    "id": "Cape Verde Standard Time",
    "displayName": "(UTC-01:00) Cabo Verde Is.",
    "standardName": "Cabo Verde Standard Time",
    "offset": -1,
    "ianaTimeZone": "Atlantic/Cape_Verde"
  },
  {
    "id": "UTC",
    "displayName": "(UTC) Coordinated Universal Time",
    "standardName": "Coordinated Universal Time",
    "offset": 0,
    "ianaTimeZone": "UTC"
  },
  {
    "id": "GMT Standard Time",
    "displayName": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
    "standardName": "GMT Standard Time",
    "offset": 0,
    "ianaTimeZone": "Europe/London"
  },
  {
    "id": "Greenwich Standard Time",
    "displayName": "(UTC+00:00) Monrovia, Reykjavik",
    "standardName": "Greenwich Standard Time",
    "offset": 0,
    "ianaTimeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "Sao Tome Standard Time",
    "displayName": "(UTC+00:00) Sao Tome",
    "standardName": "Sao Tome Standard Time",
    "offset": 0,
    "ianaTimeZone": "Africa/Sao_Tome"
  },
  {
    "id": "Morocco Standard Time",
    "displayName": "(UTC+01:00) Casablanca",
    "standardName": "Morocco Standard Time",
    "offset": 1,
    "ianaTimeZone": "Africa/Casablanca"
  },
  {
    "id": "W. Europe Standard Time",
    "displayName": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    "standardName": "W. Europe Standard Time",
    "offset": 1,
    "ianaTimeZone": "Europe/Berlin"
  },
  {
    "id": "Central Europe Standard Time",
    "displayName": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    "standardName": "Central Europe Standard Time",
    "offset": 1,
    "ianaTimeZone": "Europe/Budapest"
  },
  {
    "id": "Romance Standard Time",
    "displayName": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
    "standardName": "Romance Standard Time",
    "offset": 1,
    "ianaTimeZone": "Europe/Paris"
  },
  {
    "id": "Central European Standard Time",
    "displayName": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    "standardName": "Central European Standard Time",
    "offset": 1,
    "ianaTimeZone": "Europe/Warsaw"
  },
  {
    "id": "W. Central Africa Standard Time",
    "displayName": "(UTC+01:00) West Central Africa",
    "standardName": "W. Central Africa Standard Time",
    "offset": 1,
    "ianaTimeZone": "Africa/Lagos"
  },
  {
    "id": "GTB Standard Time",
    "displayName": "(UTC+02:00) Athens, Bucharest",
    "standardName": "GTB Standard Time",
    "offset": 2,
    "ianaTimeZone": "Europe/Bucharest"
  },
  {
    "id": "Middle East Standard Time",
    "displayName": "(UTC+02:00) Beirut",
    "standardName": "Middle East Standard Time",
    "offset": 2,
    "ianaTimeZone": "Asia/Beirut"
  },
  {
    "id": "Egypt Standard Time",
    "displayName": "(UTC+02:00) Cairo",
    "standardName": "Egypt Standard Time",
    "offset": 2,
    "ianaTimeZone": "Africa/Cairo"
  },
  {
    "id": "E. Europe Standard Time",
    "displayName": "(UTC+02:00) Chisinau",
    "standardName": "E. Europe Standard Time",
    "offset": 2,
    "ianaTimeZone": "Europe/Chisinau"
  },
  {
    "id": "West Bank Standard Time",
    "displayName": "(UTC+02:00) Gaza, Hebron",
    "standardName": "West Bank Gaza Standard Time",
    "offset": 2,
    "ianaTimeZone": "Asia/Gaza"
  },
  {
    "id": "South Africa Standard Time",
    "displayName": "(UTC+02:00) Harare, Pretoria",
    "standardName": "South Africa Standard Time",
    "offset": 2,
    "ianaTimeZone": "Africa/Johannesburg"
  },
  {
    "id": "FLE Standard Time",
    "displayName": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    "standardName": "FLE Standard Time",
    "offset": 2,
    "ianaTimeZone": "Europe/Kiev"
  },
  {
    "id": "Israel Standard Time",
    "displayName": "(UTC+02:00) Jerusalem",
    "standardName": "Jerusalem Standard Time",
    "offset": 2,
    "ianaTimeZone": "Asia/Jerusalem"
  },
  {
    "id": "South Sudan Standard Time",
    "displayName": "(UTC+02:00) Juba",
    "standardName": "South Sudan Standard Time",
    "offset": 2,
    "ianaTimeZone": "Africa/Juba"
  },
  {
    "id": "Kaliningrad Standard Time",
    "displayName": "(UTC+02:00) Kaliningrad",
    "standardName": "Russia TZ 1 Standard Time",
    "offset": 2,
    "ianaTimeZone": "Europe/Kaliningrad"
  },
  {
    "id": "Sudan Standard Time",
    "displayName": "(UTC+02:00) Khartoum",
    "standardName": "Sudan Standard Time",
    "offset": 2,
    "ianaTimeZone": "Africa/Khartoum"
  },
  {
    "id": "Libya Standard Time",
    "displayName": "(UTC+02:00) Tripoli",
    "standardName": "Libya Standard Time",
    "offset": 2,
    "ianaTimeZone": "Africa/Tripoli"
  },
  {
    "id": "Namibia Standard Time",
    "displayName": "(UTC+02:00) Windhoek",
    "standardName": "Namibia Standard Time",
    "offset": 2,
    "ianaTimeZone": "Africa/Windhoek"
  },
  {
    "id": "Jordan Standard Time",
    "displayName": "(UTC+03:00) Amman",
    "standardName": "Jordan Standard Time",
    "offset": 3,
    "ianaTimeZone": "Asia/Amman"
  },
  {
    "id": "Arabic Standard Time",
    "displayName": "(UTC+03:00) Baghdad",
    "standardName": "Arabic Standard Time",
    "offset": 3,
    "ianaTimeZone": "Asia/Baghdad"
  },
  {
    "id": "Syria Standard Time",
    "displayName": "(UTC+03:00) Damascus",
    "standardName": "Syria Standard Time",
    "offset": 3,
    "ianaTimeZone": "Asia/Damascus"
  },
  {
    "id": "Turkey Standard Time",
    "displayName": "(UTC+03:00) Istanbul",
    "standardName": "Turkey Standard Time",
    "offset": 3,
    "ianaTimeZone": "Europe/Istanbul"
  },
  {
    "id": "Arab Standard Time",
    "displayName": "(UTC+03:00) Kuwait, Riyadh",
    "standardName": "Arab Standard Time",
    "offset": 3,
    "ianaTimeZone": "Asia/Riyadh"
  },
  {
    "id": "Belarus Standard Time",
    "displayName": "(UTC+03:00) Minsk",
    "standardName": "Belarus Standard Time",
    "offset": 3,
    "ianaTimeZone": "Europe/Minsk"
  },
  {
    "id": "Russian Standard Time",
    "displayName": "(UTC+03:00) Moscow, St. Petersburg",
    "standardName": "Russia TZ 2 Standard Time",
    "offset": 3,
    "ianaTimeZone": "Europe/Moscow"
  },
  {
    "id": "E. Africa Standard Time",
    "displayName": "(UTC+03:00) Nairobi",
    "standardName": "E. Africa Standard Time",
    "offset": 3,
    "ianaTimeZone": "Africa/Nairobi"
  },
  {
    "id": "Volgograd Standard Time",
    "displayName": "(UTC+03:00) Volgograd",
    "standardName": "Volgograd Standard Time",
    "offset": 3,
    "ianaTimeZone": "Europe/Volgograd"
  },
  {
    "id": "Iran Standard Time",
    "displayName": "(UTC+03:30) Tehran",
    "standardName": "Iran Standard Time",
    "offset": 3.5,
    "ianaTimeZone": "Asia/Tehran"
  },
  {
    "id": "Arabian Standard Time",
    "displayName": "(UTC+04:00) Abu Dhabi, Muscat",
    "standardName": "Arabian Standard Time",
    "offset": 4,
    "ianaTimeZone": "Asia/Dubai"
  },
  {
    "id": "Astrakhan Standard Time",
    "displayName": "(UTC+04:00) Astrakhan, Ulyanovsk",
    "standardName": "Astrakhan Standard Time",
    "offset": 4,
    "ianaTimeZone": "Europe/Astrakhan"
  },
  {
    "id": "Azerbaijan Standard Time",
    "displayName": "(UTC+04:00) Baku",
    "standardName": "Azerbaijan Standard Time",
    "offset": 4,
    "ianaTimeZone": "Asia/Baku"
  },
  {
    "id": "Russia Time Zone 3",
    "displayName": "(UTC+04:00) Izhevsk, Samara",
    "standardName": "Russia TZ 3 Standard Time",
    "offset": 4,
    "ianaTimeZone": "Europe/Samara"
  },
  {
    "id": "Mauritius Standard Time",
    "displayName": "(UTC+04:00) Port Louis",
    "standardName": "Mauritius Standard Time",
    "offset": 4,
    "ianaTimeZone": "Indian/Mauritius"
  },
  {
    "id": "Saratov Standard Time",
    "displayName": "(UTC+04:00) Saratov",
    "standardName": "Saratov Standard Time",
    "offset": 4,
    "ianaTimeZone": "Europe/Saratov"
  },
  {
    "id": "Georgian Standard Time",
    "displayName": "(UTC+04:00) Tbilisi",
    "standardName": "Georgian Standard Time",
    "offset": 4,
    "ianaTimeZone": "Asia/Tbilisi"
  },
  {
    "id": "Caucasus Standard Time",
    "displayName": "(UTC+04:00) Yerevan",
    "standardName": "Caucasus Standard Time",
    "offset": 4,
    "ianaTimeZone": "Asia/Yerevan"
  },
  {
    "id": "Afghanistan Standard Time",
    "displayName": "(UTC+04:30) Kabul",
    "standardName": "Afghanistan Standard Time",
    "offset": 4.5,
    "ianaTimeZone": "Asia/Kabul"
  },
  {
    "id": "West Asia Standard Time",
    "displayName": "(UTC+05:00) Ashgabat, Tashkent",
    "standardName": "West Asia Standard Time",
    "offset": 5,
    "ianaTimeZone": "Asia/Tashkent"
  },
  {
    "id": "Qyzylorda Standard Time",
    "displayName": "(UTC+05:00) Astana",
    "standardName": "Qyzylorda Standard Time",
    "offset": 5,
    "ianaTimeZone": "Asia/Qyzylorda"
  },
  {
    "id": "Ekaterinburg Standard Time",
    "displayName": "(UTC+05:00) Ekaterinburg",
    "standardName": "Russia TZ 4 Standard Time",
    "offset": 5,
    "ianaTimeZone": "Asia/Yekaterinburg"
  },
  {
    "id": "Pakistan Standard Time",
    "displayName": "(UTC+05:00) Islamabad, Karachi",
    "standardName": "Pakistan Standard Time",
    "offset": 5,
    "ianaTimeZone": "Asia/Karachi"
  },
  {
    "id": "India Standard Time",
    "displayName": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    "standardName": "India Standard Time",
    "offset": 5.5,
    "ianaTimeZone": "Asia/Kolkata"
  },
  {
    "id": "Sri Lanka Standard Time",
    "displayName": "(UTC+05:30) Sri Jayawardenepura",
    "standardName": "Sri Lanka Standard Time",
    "offset": 5.5,
    "ianaTimeZone": "Asia/Colombo"
  },
  {
    "id": "Nepal Standard Time",
    "displayName": "(UTC+05:45) Kathmandu",
    "standardName": "Nepal Standard Time",
    "offset": 5.75,
    "ianaTimeZone": "Asia/Kathmandu"
  },
  {
    "id": "Central Asia Standard Time",
    "displayName": "(UTC+06:00) Bishkek",
    "standardName": "Central Asia Standard Time",
    "offset": 6,
    "ianaTimeZone": "Asia/Bishkek"
  },
  {
    "id": "Bangladesh Standard Time",
    "displayName": "(UTC+06:00) Dhaka",
    "standardName": "Bangladesh Standard Time",
    "offset": 6,
    "ianaTimeZone": "Asia/Dhaka"
  },
  {
    "id": "Omsk Standard Time",
    "displayName": "(UTC+06:00) Omsk",
    "standardName": "Omsk Standard Time",
    "offset": 6,
    "ianaTimeZone": "Asia/Omsk"
  },
  {
    "id": "Myanmar Standard Time",
    "displayName": "(UTC+06:30) Yangon (Rangoon)",
    "standardName": "Myanmar Standard Time",
    "offset": 6.5,
    "ianaTimeZone": "Asia/Yangon"
  },
  {
    "id": "SE Asia Standard Time",
    "displayName": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
    "standardName": "SE Asia Standard Time",
    "offset": 7,
    "ianaTimeZone": "Asia/Bangkok"
  },
  {
    "id": "Altai Standard Time",
    "displayName": "(UTC+07:00) Barnaul, Gorno-Altaysk",
    "standardName": "Altai Standard Time",
    "offset": 7,
    "ianaTimeZone": "Asia/Barnaul"
  },
  {
    "id": "W. Mongolia Standard Time",
    "displayName": "(UTC+07:00) Hovd",
    "standardName": "W. Mongolia Standard Time",
    "offset": 7,
    "ianaTimeZone": "Asia/Hovd"
  },
  {
    "id": "North Asia Standard Time",
    "displayName": "(UTC+07:00) Krasnoyarsk",
    "standardName": "Russia TZ 6 Standard Time",
    "offset": 7,
    "ianaTimeZone": "Asia/Krasnoyarsk"
  },
  {
    "id": "N. Central Asia Standard Time",
    "displayName": "(UTC+07:00) Novosibirsk",
    "standardName": "Novosibirsk Standard Time",
    "offset": 7,
    "ianaTimeZone": "Asia/Novosibirsk"
  },
  {
    "id": "Tomsk Standard Time",
    "displayName": "(UTC+07:00) Tomsk",
    "standardName": "Tomsk Standard Time",
    "offset": 7,
    "ianaTimeZone": "Asia/Tomsk"
  },
  {
    "id": "China Standard Time",
    "displayName": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
    "standardName": "China Standard Time",
    "offset": 8,
    "ianaTimeZone": "Asia/Shanghai"
  },
  {
    "id": "North Asia East Standard Time",
    "displayName": "(UTC+08:00) Irkutsk",
    "standardName": "Russia TZ 7 Standard Time",
    "offset": 8,
    "ianaTimeZone": "Asia/Irkutsk"
  },
  {
    "id": "Singapore Standard Time",
    "displayName": "(UTC+08:00) Kuala Lumpur, Singapore",
    "standardName": "Malay Peninsula Standard Time",
    "offset": 8,
    "ianaTimeZone": "Asia/Singapore"
  },
  {
    "id": "W. Australia Standard Time",
    "displayName": "(UTC+08:00) Perth",
    "standardName": "W. Australia Standard Time",
    "offset": 8,
    "ianaTimeZone": "Australia/Perth"
  },
  {
    "id": "Taipei Standard Time",
    "displayName": "(UTC+08:00) Taipei",
    "standardName": "Taipei Standard Time",
    "offset": 8,
    "ianaTimeZone": "Asia/Taipei"
  },
  {
    "id": "Ulaanbaatar Standard Time",
    "displayName": "(UTC+08:00) Ulaanbaatar",
    "standardName": "Ulaanbaatar Standard Time",
    "offset": 8,
    "ianaTimeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "Aus Central W. Standard Time",
    "displayName": "(UTC+08:45) Eucla",
    "standardName": "Aus Central W. Standard Time",
    "offset": 8.75,
    "ianaTimeZone": "Australia/Eucla"
  },
  {
    "id": "Transbaikal Standard Time",
    "displayName": "(UTC+09:00) Chita",
    "standardName": "Transbaikal Standard Time",
    "offset": 9,
    "ianaTimeZone": "Asia/Chita"
  },
  {
    "id": "Tokyo Standard Time",
    "displayName": "(UTC+09:00) Osaka, Sapporo, Tokyo",
    "standardName": "Tokyo Standard Time",
    "offset": 9,
    "ianaTimeZone": "Asia/Tokyo"
  },
  {
    "id": "North Korea Standard Time",
    "displayName": "(UTC+09:00) Pyongyang",
    "standardName": "North Korea Standard Time",
    "offset": 9,
    "ianaTimeZone": "Asia/Pyongyang"
  },
  {
    "id": "Korea Standard Time",
    "displayName": "(UTC+09:00) Seoul",
    "standardName": "Korea Standard Time",
    "offset": 9,
    "ianaTimeZone": "Asia/Seoul"
  },
  {
    "id": "Yakutsk Standard Time",
    "displayName": "(UTC+09:00) Yakutsk",
    "standardName": "Russia TZ 8 Standard Time",
    "offset": 9,
    "ianaTimeZone": "Asia/Yakutsk"
  },
  {
    "id": "Cen. Australia Standard Time",
    "displayName": "(UTC+09:30) Adelaide",
    "standardName": "Cen. Australia Standard Time",
    "offset": 9.5,
    "ianaTimeZone": "Australia/Adelaide"
  },
  {
    "id": "AUS Central Standard Time",
    "displayName": "(UTC+09:30) Darwin",
    "standardName": "AUS Central Standard Time",
    "offset": 9.5,
    "ianaTimeZone": "Australia/Darwin"
  },
  {
    "id": "E. Australia Standard Time",
    "displayName": "(UTC+10:00) Brisbane",
    "standardName": "E. Australia Standard Time",
    "offset": 10,
    "ianaTimeZone": "Australia/Brisbane"
  },
  {
    "id": "AUS Eastern Standard Time",
    "displayName": "(UTC+10:00) Canberra, Melbourne, Sydney",
    "standardName": "AUS Eastern Standard Time",
    "offset": 10,
    "ianaTimeZone": "Australia/Sydney"
  },
  {
    "id": "West Pacific Standard Time",
    "displayName": "(UTC+10:00) Guam, Port Moresby",
    "standardName": "West Pacific Standard Time",
    "offset": 10,
    "ianaTimeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "Tasmania Standard Time",
    "displayName": "(UTC+10:00) Hobart",
    "standardName": "Tasmania Standard Time",
    "offset": 10,
    "ianaTimeZone": "Australia/Hobart"
  },
  {
    "id": "Vladivostok Standard Time",
    "displayName": "(UTC+10:00) Vladivostok",
    "standardName": "Russia TZ 9 Standard Time",
    "offset": 10,
    "ianaTimeZone": "Asia/Vladivostok"
  },
  {
    "id": "Lord Howe Standard Time",
    "displayName": "(UTC+10:30) Lord Howe Island",
    "standardName": "Lord Howe Standard Time",
    "offset": 10.5,
    "ianaTimeZone": "Australia/Lord_Howe"
  },
  {
    "id": "Bougainville Standard Time",
    "displayName": "(UTC+11:00) Bougainville Island",
    "standardName": "Bougainville Standard Time",
    "offset": 11,
    "ianaTimeZone": "Pacific/Bougainville"
  },
  {
    "id": "Russia Time Zone 10",
    "displayName": "(UTC+11:00) Chokurdakh",
    "standardName": "Russia TZ 10 Standard Time",
    "offset": 11,
    "ianaTimeZone": "Asia/Srednekolymsk"
  },
  {
    "id": "Magadan Standard Time",
    "displayName": "(UTC+11:00) Magadan",
    "standardName": "Magadan Standard Time",
    "offset": 11,
    "ianaTimeZone": "Asia/Magadan"
  },
  {
    "id": "Norfolk Standard Time",
    "displayName": "(UTC+11:00) Norfolk Island",
    "standardName": "Norfolk Standard Time",
    "offset": 11,
    "ianaTimeZone": "Pacific/Norfolk"
  },
  {
    "id": "Sakhalin Standard Time",
    "displayName": "(UTC+11:00) Sakhalin",
    "standardName": "Sakhalin Standard Time",
    "offset": 11,
    "ianaTimeZone": "Asia/Sakhalin"
  },
  {
    "id": "Central Pacific Standard Time",
    "displayName": "(UTC+11:00) Solomon Is., New Caledonia",
    "standardName": "Central Pacific Standard Time",
    "offset": 11,
    "ianaTimeZone": "Pacific/Guadalcanal"
  },
  {
    "id": "Russia Time Zone 11",
    "displayName": "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky",
    "standardName": "Russia TZ 11 Standard Time",
    "offset": 12,
    "ianaTimeZone": "Asia/Anadyr"
  },
  {
    "id": "New Zealand Standard Time",
    "displayName": "(UTC+12:00) Auckland, Wellington",
    "standardName": "New Zealand Standard Time",
    "offset": 12,
    "ianaTimeZone": "Pacific/Auckland"
  },
  {
    "id": "UTC+12",
    "displayName": "(UTC+12:00) Coordinated Universal Time",
    "standardName": "UTC+12",
    "offset": 12,
    "ianaTimeZone": "Etc/GMT-12"
  },
  {
    "id": "Fiji Standard Time",
    "displayName": "(UTC+12:00) Fiji",
    "standardName": "Fiji Standard Time",
    "offset": 12,
    "ianaTimeZone": "Pacific/Fiji"
  },
  {
    "id": "Kamchatka Standard Time",
    "displayName": "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
    "standardName": "Kamchatka Standard Time",
    "offset": 12,
    "ianaTimeZone": "Asia/Kamchatka"
  },
  {
    "id": "Chatham Islands Standard Time",
    "displayName": "(UTC+12:45) Chatham Islands",
    "standardName": "Chatham Islands Standard Time",
    "offset": 12.75,
    "ianaTimeZone": "Pacific/Chatham"
  },
  {
    "id": "UTC+13",
    "displayName": "(UTC+13:00) Coordinated Universal Time",
    "standardName": "UTC+13",
    "offset": 13,
    "ianaTimeZone": "Etc/GMT-13"
  },
  {
    "id": "Tonga Standard Time",
    "displayName": "(UTC+13:00) Nuku'alofa",
    "standardName": "Tonga Standard Time",
    "offset": 13,
    "ianaTimeZone": "Pacific/Tongatapu"
  },
  {
    "id": "Samoa Standard Time",
    "displayName": "(UTC+13:00) Samoa",
    "standardName": "Samoa Standard Time",
    "offset": 13,
    "ianaTimeZone": "Pacific/Apia"
  },
  {
    "id": "Line Islands Standard Time",
    "displayName": "(UTC+14:00) Kiritimati Island",
    "standardName": "Line Islands Standard Time",
    "offset": 14,
    "ianaTimeZone": "Pacific/Kiritimati"
  }
];
export const LOCALE_MAP = {
  "en-US": "enUS",
  "en-GB": "enGB",
  "en-CA": "enCA",
  "en-AU": "enAU",
  "es-ES": "es",
  "es-MX": "esMX",
  "fr-FR": "fr",
  "fr-CA": "frCA",
  "de-DE": "de",
  "it-IT": "it",
  "pt-BR": "ptBR",
  "pt-PT": "pt",
  "nl-NL": "nl",
  "pl-PL": "pl",
  "ru-RU": "ru",
  "ja-JP": "ja",
  "ko-KR": "ko",
  "zh-CN": "zhCN",
  "zh-TW": "zhTW",
  "ar-SA": "ar",
  "tr-TR": "tr",
  "vi-VN": "vi",
  "th-TH": "th",
  "sv-SE": "sv",
  "da-DK": "da",
  "fi-FI": "fi",
  "nb-NO": "nb",
  "cs-CZ": "cs",
  "el-GR": "el",
  "he-IL": "he",
  "hi-IN": "hi",
  "id-ID": "id",
  "ms-MY": "ms",
  "ro-RO": "ro",
  "uk-UA": "uk"
};